angular.module('lf.common')

.directive('wrapAllAnchorsDo', function ($parse) {
  return function ($scope, $el, $attrs) {
    var fn = $parse($attrs.wrapAllAnchorsDo);
    $el.on('click', 'a', function (e) {
      e.preventDefault();
      e.stopPropagation();
      fn($scope);
    });
  }
});
